.uic-stepper {
    display: inline-block;
    padding: 8px;

    &--has-label {
        padding: 2px 8px 8px;
    }

    &__label,
    &__helper-text {
        @include truncate();
        color: var(--uic-color-black);
    }

    &__label {
        @include font(normal);
    }

    &__helper-text {
        @include font(small);
    }

    &__label:not(:empty) {
        margin-bottom: 4px;
    }

    &__helper-text:not(:empty) {
        margin-top: 3px;
    }

    &__input {
        flex: 1 1 184px;

        .uic-input-field {
            padding: 0;

            &__label {
                display: none;
            }
        }
    }

    &--invalid {
        .uic-stepper__helper-text {
            color: var(--uic-color-red1);
        }
    }

    uic-button:not([disabled]) {
        z-index: 1;
    }

    uic-button:hover,
    uic-button:active,
    uic-button:focus {
        z-index: 2;
    }

    uic-button {
        padding: 0;
    }

    &__controls {
        display: flex;
        align-items: center;
    }

    &__increase,
    &__decrease,
    &__increase_to_max,
    &__decrease_to_min {
        padding: 0;
    }

    &__increase,
    &__decrease_to_min {
        --uic-button-shadow: 1px 3px 4px -1px var(--uic-atom-shadow-color-primary),
            1px 3px 8px -1px var(--uic-atom-shadow-color-secondary);
    }

    &__decrease,
    &__increase_to_max {
        --uic-button-shadow: -1px 3px 4px -1px var(--uic-atom-shadow-color-primary),
            -1px 3px 8px -1px var(--uic-atom-shadow-color-secondary);
        margin-right: -1px;
        margin-left: 4px;
    }
}
